import { useEffect, useMemo } from "react";

import { Button } from "neetoui";
import { useTranslation } from "react-i18next";

import { ElementPopupPlaceholderImage } from "../PlaceholderImages";

const ElementPopup = ({ iframeURL }) => {
  const { t } = useTranslation();

  /**
   * Currently embed() function doesn't have an unembed handler.
   * When iframe link changes, we don't have an option to reinitiate it.
   * So we forcefully recreate the element with `key` and call embed() again
   */
  const elementSelectorId = useMemo(
    () => `popup-button-${Math.random().toString().substring(2, 10)}`,
    [iframeURL]
  );

  useEffect(() => {
    const element = document.getElementById(elementSelectorId);
    if (!element) return;

    const appName = globalProps.appName.replace(/^neeto/i, "neeto");
    window[appName]?.embed(element, iframeURL);
  }, [iframeURL]);

  return (
    <div className="relative h-full w-full overflow-hidden">
      <ElementPopupPlaceholderImage className="neeto-ui-text-gray-100 absolute inset-0 h-auto w-full p-10" />
      <Button
        className="absolute start-[48.5294117647%] top-[39.0804597701%]"
        data-testid="preview-element-popup-button"
        id={elementSelectorId}
        key={elementSelectorId}
        label={t("neetoMolecules.productEmbed.elementPopup.label")}
      />
    </div>
  );
};

export default ElementPopup;
